import React from "react";

export type SampleBadgeOutProps = {
    onClickHandler?: () => void,
}

export const SampleBadgeOut: React.FC<SampleBadgeOutProps> = ({onClickHandler}) => {
    
    function handleClick(e) {
        e.stopPropagation();
        onClickHandler && onClickHandler();
    }
    
    return (
        <span className="badge badge-warning ml-2 btn-link li-pointer" onClick={handleClick}>OUT</span>
    );
};